export default __webpack_public_path__ + "static/media/Banner-Svedka.20fa1e9b.png";